import Cookies from "js-cookie";

const app = {
  state: {
    sidebar: {
      opened: false,
      isShowSidebarBtn: true,
      withoutAnimation: true
    },
    isShowFooter: false,
    device: "desktop",
    language: Cookies.get("language") || "en",
    size: Cookies.get("size") || "medium",
    menu: [],
    shopTypeDataMap: {
      shopType: [], // 店铺类型
      shopTypeSelf: [], // 店铺类型（过滤后）
      cooperationType: [], // 合作类型
      shopCategoryFull: [], // 店铺标签(**店)
      shopCategory: [], // 店铺标签
      shopCategorySelf: [], // 店铺标签（过滤后）
      shopCategoryFullSelf: [] // 店铺标签（过滤后）(**店)
    },
    shopTypeDataObjMap: {
      shopType: {}, // 店铺类型
      shopTypeSelf: {}, // 店铺类型（过滤后）
      cooperationType: {}, // 合作类型
      shopCategoryFull: {}, // 店铺标签(**店)
      shopCategory: {}, // 店铺标签
      shopCategorySelf: {}, // 店铺标签（过滤后）
      shopCategoryFullSelf: {} // 店铺标签（过滤后）(**店)
    },
    currentMenuArr: [],
    appId: "",
    isShowDialog: false,
    isShowSimpleFooter: false,
    isEmpFooter: true,
    message: {
      title: "提示",
      msg: "您尚未登录，请先登录",
      btn: "去登录",
      isLogout: true
    },
    loadingMessage: "加载中,请稍等...",
    pageLoading: {
      pageLoadingStatus: false,
      pageLoadingEnable: false
    },
    routerPower: {
      isShow: false,
      message: ""
    }
  },
  mutations: {
    SET_IS_SHOW_DIALOG: (state, isShowDialog) => {
      state.isShowDialog = isShowDialog;
    },
    SET_MESSAGE: (state, message) => {
      state.message = message;
    },
    SET_LOADINGMESSAGE: (state, loadingMessage) => {
      state.loadingMessage = loadingMessage;
    },
    SET_PAGELOADING: (state, status) => {
      state.pageLoading.pageLoadingStatus = status;
    },
    SET_PAGELOADINGENABLE: (state, status) => {
      state.pageLoading.pageLoadingEnable = status;
    },
    SET_APP_ID: (state, appId) => {
      state.appId = appId;
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = true;
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
    },
    OPEN_SIDEBAR_TEMPORARY: state => {
      state.sidebar.opened = true;
    },
    CLOSE_SIDEBAR_TEMPORARY: state => {
      state.sidebar.opened = false;
    },
    SHOW_SIDEBAR_BTN: state => {
      state.sidebar.isShowSidebarBtn = true;
    },
    HIDE_SIDEBAR_BTN: state => {
      state.sidebar.isShowSidebarBtn = false;
    },
    SHOW_FOOTER: state => {
      state.isShowFooter = true;
    },
    HIDE_FOOTER: state => {
      state.isShowFooter = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_SIZE: (state, size) => {
      state.size = size;
      Cookies.set("size", size);
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
    },

    SET_CURRENT_MENU_ARR: (state, currentMenuArr) => {
      state.currentMenuArr = currentMenuArr;
    },

    SET_ROUTER_305: (state, routerPower) => {
      state.routerPower = routerPower;
    },

    SET_SHOW_SIMPLE_FOOTER: (state, isShowSimpleFooter) => {
      state.isShowSimpleFooter = isShowSimpleFooter;
    },

    SET_EMP_FOOTER: (state, isEmpFooter) => {
      state.isEmpFooter = isEmpFooter;
    },
    SET_SHOP_TYPE_MAP: (state, map) => {
      // 过滤掉二级集采店 云租店铺 物流店铺 云仓店铺
      const shopTypeSelf = map.shopType.filter(item => {
        return !["6", "7", "8", "9"].includes(item.code);
      });
      const shopCategoryFull = map.shopCategory.map(item => {
        return {
          ...item,
          label: `${item.label}${item.label.length > 2 ? "" : "店"}`
        };
      });
      const shopCategoryFullSelf = shopCategoryFull.filter(item => {
        return !["4", "5", "6", "7"].includes(item.code);
      });
      // 过滤掉厂商资源 云租店铺 物流店铺 云仓店铺
      const shopCategorySelf = map.shopCategory.filter(item => {
        return !["4", "5", "6", "7"].includes(item.code);
      });
      const shopTypeDataMap = {
        ...map,
        shopTypeSelf,
        shopCategoryFull,
        shopCategoryFullSelf,
        shopCategorySelf
      };
      state.shopTypeDataMap = shopTypeDataMap;
      Object.entries(shopTypeDataMap).forEach(([key, item]) => {
        const obj = {};
        item.forEach(n => {
          obj[n.value] = n.label;
        });
        state.shopTypeDataObjMap[key] = obj;
      });
    }
  },
  actions: {
    setAppId({ commit }, appId) {
      commit("SET_APP_ID", appId);
    },
    toggleSidebar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    closeSidebar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    openSidebarTemporary({ commit }) {
      commit("OPEN_SIDEBAR_TEMPORARY");
    },
    closeSidebarTemporary({ commit }) {
      commit("CLOSE_SIDEBAR_TEMPORARY");
    },
    showSidebarBtn({ commit }) {
      commit("SHOW_SIDEBAR_BTN");
    },
    hideSidebarBtn({ commit }) {
      commit("HIDE_SIDEBAR_BTN");
    },
    showFooter({ commit }) {
      commit("SHOW_FOOTER");
    },
    hideFooter({ commit }) {
      commit("HIDE_FOOTER");
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setSize({ commit }, size) {
      commit("SET_SIZE", size);
    },
    setMenu({ commit }, menu) {
      commit("SET_MENU", menu);
    },
    setCurrentMenuArr({ commit }, currentMenuArr) {
      commit("SET_CURRENT_MENU_ARR", currentMenuArr);
    },
    setPageLoading: ({ commit }, status) => {
      commit("SET_PAGELOADING", status);
    },
    setPageLoadingEnable: ({ commit }, status) => {
      commit("SET_PAGELOADINGENABLE", status);
    },
    setRouter305: ({ commit }, routerPower) => {
      commit("SET_ROUTER_305", routerPower);
    },
    setShowSimpleFooter: ({ commit }, isShowSimpleFooter) => {
      commit("SET_SHOW_SIMPLE_FOOTER", isShowSimpleFooter);
    },
    setShowisEmpFooter: ({ commit }, isEmpFooter) => {
      commit("SET_EMP_FOOTER", isEmpFooter);
    },
    setShopTypeMap({ commit }, map) {
      commit("SET_SHOP_TYPE_MAP", map);
    }
  }
};

export default app;
